import { useCallback } from 'react';

export const useGetTypeForIndex = (selectedIndex: number) =>
  useCallback(
    (index: number) => {
      if (index === selectedIndex) {
        return 'selected';
      }

      if (index < selectedIndex) {
        return 'checked';
      }

      return 'unchecked';
    },
    [selectedIndex],
  );
